import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { SectionCta } from "../SectionCta";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-272" data-mp="3mgsh9wmysp55">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-prepare text-prepare" aria-hidden="true" data-id="element-273" data-mp="3r80vr735j0p6" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-274" data-mp="3k9e7itkvth">
      <div className="mx-auto max-w-5xl" data-id="element-275" data-mp="41hxf70utbva">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-276" data-mp="44nlqk1ns9py">
          What other <em className="text-brand" data-id="element-277" data-mp="e0qnvpwig8cw">dentists are saying</em>
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-278" data-mp="dywcb274pslh">
          <Stars data-id="element-279" data-mp="2autusax0ww9i" />
          <span className="text-lg font-black text-ink" data-id="element-280" data-mp="2avddvuyetqp4">4.9/5</span>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-281" data-mp="2fsvodps2sdz8">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-slate-200 bg-canvas p-6" data-id="element-282" data-mp="1slu7iav985bj">
              <QuoteIcon className="h-7 w-7 text-brand" aria-hidden="true" data-id="element-283" data-mp="1nrq1puxq63c1" />
              <p className="mt-3 font-serif text-xl font-black leading-snug text-ink" data-id="element-284" data-mp="1iv984l7rawrk">"{t.headline}"</p>
              <blockquote className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-285" data-mp="1euz6tluwsuj1">{t.text}</blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-286" data-mp="2bilvuypnlamg">
                <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full border-2 border-white object-cover shadow-md" data-id="element-287" data-mp="26llq6owpu9vv" />
                <div data-id="element-288" data-mp="22kjrqaami1uy">
                  <p className="font-bold text-ink" data-id="element-289" data-mp="1xjvxzgv0f6x1">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-290" data-mp="1xlqcacbs00s5">{t.country}</p>
                  <Stars data-id="element-291" data-mp="r4bk3ugc40cf" />
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCta label="I want results like these" data-id="element-292" data-mp="m35onovahyz7" />
      </div>
    </section>;
}